import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { combineLatest, filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TllLoginRedirectService } from '../services/tll-login-redirect.service';

@Injectable({ providedIn: 'root' })
export class TllGuestLoginGuard implements CanActivate {
  private readonly auth = inject(AuthService);
  private readonly tllLoginRedirect = inject(TllLoginRedirectService);

  canActivate() {
    return combineLatest([this.auth.authReady$, this.auth.isAuthenticated$]).pipe(
      filter(([ready]) => !!ready),
      take(1),
      map(([_, isAuth]) => {
        if (!isAuth && this.tllLoginRedirect.shouldRedirectGuestToLogin()) {
          this.tllLoginRedirect.redirectToLogin();
          return false;
        }
        return true;
      }),
    );
  }
}
